module.exports = __webpack_public_path__ + "media/images/athletes/1821-6a8bf24f5c3915c6b26c0109cab5386b.png";